import React, { useRef, useEffect, useCallback, useState } from 'react';
import { useSelector, connect } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import routeConstant from '../../lib/constants/routeConstant';
import Navbar from '../../components/Navbar/Navbar';
import CommonLoader from '../../components/shared/Loaders/CommonLoader/CommonLoader';
import DeployToken  from '../../components/DeployToken/DeployToken';
import token_unavailable from '../../assets/images/token_unavailable.png';
import { getOwnedTokens } from '../../redux/slices/deployTokenSlice';
import Button from '../../components/shared/Button/Button';
import { getGameDetails } from '../../redux/slices/scorerSlice';

const DeployTokenPage = ({ purchasedTokens, getGame }) => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const apiDataRef = useRef(false);
  // Extract matchId from state
  const matchId = state?.matchId;
  
  // Access the current season and fetched status
  const { currentSeason } = useSelector((state) => state.seasons);
  const { fetchingGame, fetchGameError } = useSelector(state => state.scorer);
  const { tokens, tokenLoading } = useSelector((state) => state.deployToken);

  const [selectedTokenId, setSelectedTokenId] = useState(0); // selected Token index [0, 1, 2, ...]
  const [editTokenId, setEditTokenId] = useState(null);      // Edit Token index null/ [0, 1, 2, ...]
  const [currentStep, setCurrentStep] = useState(1);         // current step [step-1, step-2]

  // Redirect if matchId is missing
  useEffect(() => {
    if (!matchId || fetchGameError) {
      navigate(routeConstant.PAGE_NOT_FOUND); // Redirect to your desired fallback page
    }
  }, [matchId, fetchGameError]);

  const callApi = useCallback(async () => {
    if (apiDataRef.current || !currentSeason?._id) return;
    apiDataRef.current = true;

    const data = {
      gameId: matchId
    }

    const _game = await getGame(data);
    if(getGameDetails.fulfilled.match(_game)) {
      // data to be sent in purchased-tokens
      const data = {
        seasonId: _game?.payload?.seasonId,
        matchId: matchId,
      };
      
      await purchasedTokens(data);
    }
  }, [currentSeason]);

  //function to refresh tokens (when deployed)
  const refreshTokens = () => {
    const data = {
      seasonId: currentSeason._id,
      matchId: matchId,
    };
    
    purchasedTokens(data);
  };

  // Trigger callApi only when currentSeason is available
  useEffect(() => {
    if (currentSeason) {
      callApi();
    }
  }, [callApi, currentSeason]);

  useEffect(() => {
    // whenever updated selected token index
    setCurrentStep(1); // Reset to step 1 when switching tokens
    setEditTokenId(null);
  }, [selectedTokenId])

  if (tokenLoading || fetchingGame) {
    return <CommonLoader />;
  }
  // Get the selected token data
  const selectedTokenData = tokens?.length > 0 ? tokens[selectedTokenId] : null;
  // console.log(selectedTokenData)

  return (
    <main>
      <Navbar />
      {/* Conditionally check if tokens are available or not */}
      {(tokens?.length === 0) && !tokenLoading ? (
        <div className='flex flex-col items-center gap-[20px]'>
          <img src= {token_unavailable} alt="token unavailable" className='max-h-[220px] max-w-[220px] sm:max-h-[400px] sm:max-w-[400px]'/>
          <span className='text-[14px] px-2 sm:text-[20px] font-Suisse text-primaryHeading text-center'>No tokens are available for deployment in this game.</span>
          <Button variant='primary' onClick={() => navigate(routeConstant.SELECT_SPORT_PAGE)}>Buy Tokens</Button>
        </div>
      ) : (
        // Deploy Token Component
        <DeployToken
          matchId={matchId}
          refreshTokens={refreshTokens}
          selectedTokenId={selectedTokenId}
          setSelectedTokenId={setSelectedTokenId}
          editTokenId={editTokenId}
          setEditTokenId={setEditTokenId}
          currentStep={currentStep}
          setCurrentStep={setCurrentStep}
          selectedTokenData={selectedTokenData}
        />
      )}
    </main>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    purchasedTokens: (data) => dispatch(getOwnedTokens(data)),
    getGame: (data) => dispatch(getGameDetails(data)),
  };
};

export default connect(null, mapDispatchToProps)(DeployTokenPage);
